import { cycleWindowBounds, formatQuotaResetAt } from '../../../shared-types/src/index.js';
import type { QuotaCycle } from '../../../shared-types/src/index.js';

/**
 * Start of the window `resetAt` closes, as an ISO instant.
 *
 * Cycles are fixed UTC calendar windows, so the start is implied — but a
 * counter is only intelligible once you can see WHICH span it covers ("400 of
 * 1000" means nothing without knowing the period began an hour ago).
 *
 * Anchored on the server's `resetAt`, not on the browser clock: one
 * millisecond before the exclusive end is always inside the current window, so
 * this asks the SAME `cycleWindowBounds` the gateway enforces with, about the
 * SAME instant the server already committed to. A skewed client cannot shift
 * it, and calendar math is not duplicated here.
 */
export function cycleWindowStart(cycle: QuotaCycle, resetAt: string | undefined): string | undefined {
  if (!resetAt || cycle === 'lifetime') return undefined;
  const end = Date.parse(resetAt);
  if (Number.isNaN(end)) return undefined;
  return cycleWindowBounds(cycle, end - 1).from;
}

/** The server's `resetAt` is UTC-anchored and authoritative. Only the DISPLAY
 *  is localized — never re-derive a window in the browser, or the screen and
 *  the gateway will disagree the moment a timezone or DST rule differs. */
export function formatResetAt(iso: string | undefined, locale: string): string | undefined {
  return formatQuotaResetAt(iso, locale);
}
